export const END_POINTS = {
  PROVINCE: 'provinces',
  REGION: 'regions',
  PHC_SERVICES: 'phc-services',
  PHC_WORKERS_BY_PHC_SERVICE: 'phc-workers/list/by-phc-service',
  PHC_WORKERS_DELETE_CHAT_ROOM: 'phc-workers/delete-chat-room/by-id',
  USER_OPTION_LIST: 'therapist/option/list',
  PATIENT_REFERRAL: 'patient-referrals',
  PATIENT_REFERRAL_ASSIGNMENT: 'patient-referral-assignments',
  PATIENT_REFERRAL_ASSIGNMENT_COUNT: 'patient-referral-assignments/count',
  PATIENT: 'patient',
  PROVINCE_BY_USER_COUNTRY: 'provinces-by-user-country',
  CLINIC_BY_USER_COUNTRY: 'clinics-by-user-country',
  TRANSFER: 'transfer',
  APPOINTMENTS: 'appointments',
  APPOINTMENTS_MARK_AS_READ: 'appointments/bulk/mark-as-read',
  REFERRAL_THERAPISTS: 'phc-workers/get-referral-therapists',
  THERAPISTS_BY_CLINIC: 'therapist/list/by-clinic-id',
  PHC_WORKERS_WITH_ACCEPTED_REFERRALS: 'therapist/phc-workers/with-accepted-referrals',
  INTERVIEW_HISTORY: 'screening-questionnaires-history-by-patient-list',
};
